import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TabsView, TextView } from 'components';
import { BASE_URLS } from 'constants/urls';
import {
  selectContentIndex,
  selectSelectedContentIndex,
  selectTemplateContents,
} from 'redux/content/content.slice';
import { styled } from 'styled-components';

import ContentPreview from './ContentPreview';
import RightComponent from './RightComponent';

export const MobileImage = styled.div<{ imageUrl: string }>`
  width: 100%;
  height: 100%;
  background-image: ${(props: { imageUrl: string }) => {
    return `url(${props.imageUrl})`;
  }};
  background-repeat: no-repeat;
`;

export const MessageWrapper = styled.div`
  &:after {
    content: '';
    width: 20px;
    height: 12px;
    background-image: url('${BASE_URLS.ASSETS}/assets/message-pointer.svg');
    position: absolute;
    bottom: 19px;
    left: -9px;
    background-repeat: no-repeat;
  }
`;
const RightPanel = () => {
  const templateContents = useSelector(selectTemplateContents);
  const selectedContentIndex = useSelector(selectSelectedContentIndex);
  const dispatch = useDispatch();

  const tabsLanguages: React.ComponentProps<typeof TabsView>['tabItems'] =
    templateContents
      .map((item, index) => ({
        key: index.toString(),
        title: item.language,
        children: '',
      }))
      .filter((item) => item.title !== '');

  return (
    <RightComponent>
      <div className="pl-[40px] z-[999]">
        <TextView
          textType="body"
          color="#101828"
          size={18}
          fontStyle="normal"
          weight="700"
          lineHeight={28}
          text={'Content preview: '}
        />
        <TextView
          textType="body"
          color="#475467"
          size={16}
          fontStyle="normal"
          weight="100"
          lineHeight={20}
          text={
            'Preview the content on the mobile phone or device you are using to see how recipient will view the template.'
          }
        />
      </div>

      <div className="flex flex-col justify-start gap-4 items-center h-full pl-[40px] pb-5 z-[999]">
        <div className="w-full flex justify-start">
          <div
            className="overflow-auto"
            style={{ borderRadius: 6, border: '1px solid #D0D5DD', padding: 4 }}
          >
            <TabsView
              activeKey={selectedContentIndex.toString()}
              tabItems={tabsLanguages}
              onTabClick={(key: string) => {
                dispatch(
                  selectContentIndex({ selectedContentIndex: parseInt(key) })
                );
              }}
              variant="advanced"
            />
          </div>
        </div>
        <ContentPreview />
      </div>
    </RightComponent>
  );
};
export default RightPanel;
